"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PagedTableField = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = require("lodash");
const table_field_1 = require("../table-field/table-field");
const paged_table_field_row_1 = require("./paged-table-field-row");
const paged_table_field_context_1 = require("./paged-table-field-context");
const paged_table_field_hook_1 = require("./paged-table-field-hook");
const compose_refs_1 = require("../../utils/compose-refs");
const event_callback_hook_1 = require("../../utils/event-callback-hook");
exports.PagedTableField = react_1.forwardRef(function PagedTableField({ maxRows, source, ...options }, ref) {
    var _a, _b, _c;
    const { page, rowsPerPage, discoveredPages, refreshPager, PaginationComponent, } = paged_table_field_hook_1.usePagination(source.count, maxRows);
    const innerRef = react_1.useRef(null);
    const composedRef = compose_refs_1.composeRefs(innerRef, ref);
    react_1.useEffect(() => {
        source.setParams({ ...source.getParams(), size: rowsPerPage });
        if (source.items.length < rowsPerPage) {
            source.loadMore();
        }
        const resetIndex = () => { var _a; return (_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(undefined); };
        resetIndex();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [rowsPerPage]);
    react_1.useEffect(() => {
        if (discoveredPages.length && !discoveredPages.includes(page)) {
            source.loadMore();
        }
        const resetIndex = () => { var _a; return (_a = innerRef === null || innerRef === void 0 ? void 0 : innerRef.current) === null || _a === void 0 ? void 0 : _a.setSelectedIndex(undefined); };
        resetIndex();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [page]);
    react_1.useEffect(() => {
        var _a;
        if (((_a = source === null || source === void 0 ? void 0 : source.items) !== null && _a !== void 0 ? _a : []).length === 0) {
            refreshPager();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [source.items]);
    const handleSortChange = event_callback_hook_1.useEventCallback((sort) => {
        source.setParams({
            ...source.getParams(),
            sort,
        });
        source.reset();
        source.loadMore();
    });
    return (react_1.default.createElement(paged_table_field_context_1.PagedTableFieldContext.Provider, { value: {
            page,
            rowsPerPage,
            source,
        } },
        react_1.default.createElement(table_field_1.TableField, Object.assign({ maxRows: rowsPerPage, ref: composedRef, FooterComponent: PaginationComponent, RowComponent: paged_table_field_row_1.PagedTableFieldRow }, options, { onChange: lodash_1.noop, defaultSort: (_b = (_a = source.getParams()) === null || _a === void 0 ? void 0 : _a.sort) !== null && _b !== void 0 ? _b : [], onSortChange: handleSortChange, value: (_c = source.items) === null || _c === void 0 ? void 0 : _c.slice(page * rowsPerPage, (page + 1) * rowsPerPage) }))));
});
//# sourceMappingURL=paged-table-field.js.map